export default __webpack_public_path__ + "static/media/image32.400f04df.png";